import styled from 'styled-components';

import { Flex } from '@cognite/cogs-core-v11/components/flex/flex.tsx';

import { Card as BaseCard } from '../features/ui/card/card';

export const PageContainerStyle = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  min-height: -webkit-fill-available;
  height: 100dvh;
  display: flex;
  flex-flow: column;
  overflow: hidden;
  overflow-wrap: break-word;
  > main {
    flex: 1;
    min-height: 0;
    overflow: auto;
  }
`;

export const Container = styled(Flex).attrs({
  alignItems: 'stretch',
  gap: 12,
})`
  padding: 12px 12px;
  height: 100%;
`;

export const Card = styled(BaseCard)`
  min-width: 375px;
`;

export const PageNotFoundContainer = styled(Flex).attrs({
  alignItems: 'center',
  justifyContent: 'center',
})`
  padding: 16px;
  height: 100%;
  width: 100%;
`;
